import { PlaybackEndReason } from '../../../model/PlaybackEndReason';
import { PlaybackStartupObservation } from '../../../model/PlaybackStartupObservation';
import {
  GodavariEndReason,
  GodavariPulseObservation,
  GodavariPulseMicroStep,
  GodavariPulsePlayerState,
  GodavariPulseStep,
} from '../model/GodavariPayload';

const operations: Record<PlaybackStartupObservation['operation'], [GodavariPulseStep, GodavariPulsePlayerState]> = {
  'playback-authorization': ['VideoUrlFetch', 'VideoUrl'],
  'license-authorization': ['LAUrl', 'LAUrl'],
  license: ['LicenceUrlFetch', 'LicenceUrl'],
  manifest: ['ManifestFetch', 'Manifest'],
  segment: ['ChunkDownload', 'Chunk'],
  concurrency: ['ConcurrencyCheck', 'Concurrency'],
  ad: ['AdPlay', 'Ad'],
};
const milestones: Record<NonNullable<PlaybackStartupObservation['milestone']>, GodavariPulseMicroStep> = {
  'request-start': 'RequestStart',
  'response-end': 'ResponseEnd',
  'response-error': 'ResponseError',
  'parsing-start': 'ParsingStart',
  'parsing-end': 'ParsingEnd',
  'segment-number': 'ChunkNumber',
};
const states: Record<NonNullable<PlaybackStartupObservation['state']>, GodavariPulsePlayerState> = {
  loading: 'Buffering',
  buffering: 'Buffering',
  ready: 'Ready',
  playing: 'Playing',
};
const reasons: Record<PlaybackEndReason, GodavariEndReason> = {
  'user-stop': 'UserIntent',
  'content-change': 'AssetClick',
  'automatic-retry': 'AutoRetry',
  'automatic-advance': 'Binge',
};

export function toGodavariEndReason(reason: PlaybackEndReason): GodavariEndReason | undefined {
  return reasons[reason];
}

export function toGodavariStartupObservation(observation: PlaybackStartupObservation): GodavariPulseObservation {
  const [step, state] = operations[observation.operation];
  const retryCount = observation.retryCount;
  let pulseRetry: 0 | 1 | undefined;
  if (retryCount !== undefined) pulseRetry = retryCount > 0 ? 1 : 0;
  return {
    pulse_start_steps: step,
    pulse_micro_steps: observation.milestone ? milestones[observation.milestone] : 'NA',
    pulse_player_state: observation.state ? states[observation.state] : state,
    pulse_player_retry: pulseRetry,
    timestamp: observation.timestamp,
    requestId: observation.requestId,
    retryFromStart: observation.retryFromStart,
    autoPlayAllowed: observation.autoplayAllowed,
  } as GodavariPulseObservation;
}
